import { ThemeEvents } from '@theme/events';

/**
 * <free-shipping-pill>
 *
 * Variant değişiminde section re-render HTML'inden kendini bulup
 * iç içeriğini ve görünürlüğünü günceller. wire-discount-card deseniyle
 * birebir aynı yaklaşım.
 */
class FreeShippingPill extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  disconnectedCallback() {
    if (this.section) {
      this.section.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
    }
  }

  handleVariantUpdate = (event) => {
    const detail = event.detail ?? {};
    const data = detail.data ?? {};

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const html = data.html;
    if (!html) return;

    const replacement = html.querySelector(`free-shipping-pill[data-block-id="${this.dataset.blockId}"]`);
    if (!replacement) {
      this.hidden = true;
      this.classList.add('free-shipping--hidden');
      return;
    }

    if (replacement.hasAttribute('hidden')) {
      this.hidden = true;
      this.classList.add('free-shipping--hidden');
    } else {
      this.hidden = false;
      this.classList.remove('free-shipping--hidden');
    }

    const newInner = replacement.querySelector('[data-free-shipping-root]');
    const currentInner = this.querySelector('[data-free-shipping-root]');
    if (newInner && currentInner) {
      currentInner.replaceWith(newInner);
    }
  };
}

if (!customElements.get('free-shipping-pill')) {
  customElements.define('free-shipping-pill', FreeShippingPill);
}
